import { BolsaCentro } from '../types';

// SPEC-113 (RN-002, RN-004) — coincidencia parcial case-insensitive sobre cliente_razon_social,
// mismo criterio que el buscador de Cotizaciones (SPEC-107) pero sobre las tarjetas del kanban.
export function filtrarPorCliente(cotizaciones: BolsaCentro[], busqueda: string): BolsaCentro[] {
  const q = busqueda.trim().toLowerCase();
  if (!q) return cotizaciones;
  return cotizaciones.filter((b) => (b.cliente_razon_social ?? '').toLowerCase().includes(q));
}
